// extracted by mini-css-extract-plugin
module.exports = {"link":"_2Zvo9X","name":"_3C0UZP","image":"L4DRGf"};